<template>
  <div class="task-component">
    <jd-button type="blue" @click="addTask" class="mb16">{{
      addTaskBtnText
    }}</jd-button>
    <span class="extra-text ml8" v-if="extraText">{{ extraText }}</span>
    <jd-table
      v-if="taskDataList.length > 0"
      :tableData="taskDataList"
      style="width: 100%"
    >
      <el-table-column label="任务" width="80px">
        <template slot-scope="scope">
          <span>任务{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="任务类型" width="130px">
        <template slot-scope="scope">
          <span>{{ getTaskType(scope.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="自定义任务名称" v-if="isShowCustom" width="300px">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.taskName"
            placeholder="请输入"
            show-word-limit
            maxlength="16"
          />
        </template>
      </el-table-column>
      <el-table-column label="任务条件" prop="condition">
        <template slot-scope="scope">
          <!-- 鼠标移入显示完整内容 -->
          <el-tooltip
            :content="getCondition(scope.row)"
            placement="top"
            v-if="isShowCustom"
          >
            <span style="white-space: pre">{{ getCondition(scope.row) }}</span>
          </el-tooltip>
          <span style="white-space: pre" v-else>{{
            getCondition(scope.row)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="自定义任务描述" v-if="isShowCustom">
        <template slot-scope="scope">
          <div class="pdtb8">
            <el-input
              type="textarea"
              :rows="3"
              v-model="scope.row.taskDesc"
              placeholder="请输入"
              show-word-limit
              maxlength="50"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="任务次数" prop="count">
        <template slot-scope="scope">
          <span>{{ getCount(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" :width="isShowCustom ? '260px' : 'auto'">
        <template slot-scope="scope">
          <jd-button
            :disabled="
              (scope.row.type != 20 &&
                activityData.isStart &&
                !scope.row.isAdd) ||
              (activityData.isStart &&
                !scope.row.isAdd &&
                scope.row.type == 20 &&
                scope.row.skuType == 0&&
                !scope.row.isAdd)
            "
            type="blueText"
            style="margin-right: 8px"
            @click="editTask(scope.row, false)"
            >修改</jd-button
          >
          <jd-button
            type="blueText"
            style="margin-right: 8px"
            @click="editTask(scope.row, true)"
            >查看</jd-button
          >
          <jd-button
            type="blueText"
            style="margin-right: 8px"
            v-if="
              (taskDataList.length > 1 && activityData.isStart) ||
              (taskDataList.length > 0 && !activityData.isStart)
            "
            @click="deleteTask(scope.row)"
            >删除</jd-button
          >
          <jd-button
            :disabled="
              isDisabled ? activityData.isStart && !scope.row.isAdd : false
            "
            type="blueText"
            style="margin-right: 8px"
            @click="upTask(scope.$index)"
            v-if="scope.$index != 0"
            >上移</jd-button
          >
          <jd-button
            :disabled="
              isDisabled ? activityData.isStart && !scope.row.isAdd : false
            "
            type="blueText"
            @click="downTask(scope.$index)"
            v-if="scope.$index != taskDataList.length - 1"
            >下移</jd-button
          >
        </template>
      </el-table-column>
    </jd-table>
    <!-- 添加任务 -->
    <jd-dialog
      :title="`${isTaskEdit ? '修改任务' : '添加任务'}`"
      :visible.sync="taskDialog"
      :width="taskForm.type == 20 ? '750px' : taskForm.type == 17 ? '800px' : '680px'"
      :isShowSure="!taskIsLook"
      v-if="taskDialog"
      @close="taskClose"
      @confirm="sureTask"
    >
      <el-form
        :model="taskForm"
        style="position: relative"
        class="new-input-box"
        label-width="auto"
      >
        <div
          v-if="taskIsLook"
          style="
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 1;
          "
        ></div>
        <el-form-item label="任务类型:" required>
          <el-select
            v-model="taskForm.type"
            style="width: 350px"
            @change="taskTypeChange"
            :disabled="isNeedDisabled(taskForm) && taskForm.type == 20"
          >
            <el-option
              v-for="item in taskTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="task-tip-wrap">
          <jd-tip class="task-tip" v-if="taskForm.type == 1">
            <div>
              任务说明：用户每日都可进入活动页签到，获得{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}。
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 2">
            <div>
              任务说明：用户每日都可进入活动页浏览店铺，获得{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}。
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 13">
            <div>任务说明：</div>
            <div>
              1.用户浏览商品可以获得{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}；
            </div>
            <div>2.商品是以单个SKU为单位，浏览同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 4">
            <div>任务说明：</div>
            <div>
              1.用户成功加购商品可以获得{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}；
            </div>
            <div>2.商品是以单个SKU为单位，加购同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 9">
            <div>任务说明：</div>
            <div>
              1.用户成功分享商品可以获得{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}；
            </div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 10">
            <div>任务说明：</div>
            <div>
              1.用户成功分享店铺可以获得{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}；
            </div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 11">
            <div>任务说明：</div>
            <div>
              1.用户成功分享活动可以获得{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}；
            </div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 8">
            <div>任务说明：</div>
            <div>
              1.用户成功邀请好友可以获得{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}；
            </div>
            <div>
              2.被邀请人只有点击助力链接才算一次有效助力，且活动期间每人只有1次助力机会；
            </div>
            <div>3.用户在活动期间内可以做此任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 5">
            <div>任务说明：</div>
            <div>1.此任务可以放链接，必须遵从以下规则：</div>
            <div>（1） 链接须包含 .isvjcloud.com，.isvjd.com或.jd.com</div>
            <div>（2） 只能以http://,https://开头</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 12">
            <div>任务说明：</div>
            <div>
              1.用户成功预约商品可以获得{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}；
            </div>
            <div>2.商品是以单个SKU为单位，预约同一个商品多次按1次计算；</div>
            <div>3.用户在活动时间期间内可以做此任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 16">
            <div>
              任务说明：用户消耗一定积分可兑换{{ mainText
              }}{{ isShowUnit ? "机会次数" : "" }}。
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 17">
            <div>
              <div>任务说明：</div>
              <div>
                1、因官方接口限制，POP统计订单实付金额，自营统计订单金额（是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。）；
              </div>
              <div>2、指定购买商品：订单包含任意指定商品均会被统计；</div>
              <div>
                3、选择订单状态为“已完成”，则仅限交易完成的订单可获得{{
                  mainText
                }}机会，如：活动已结束，交易未完成，则不赠送{{
                  mainText ? mainText : "次数"
                }}；
              </div>
              <div>
                4、如买家通过消费任务获得次数后进行退款的情况，已赠送的次数不会撤回；
              </div>
              <div style="color: #fe4d45">
                5、如设置【购物任务】条件，则活动对象设置必须为会员身份，接口限制非会员无法统计交易数据。
              </div>
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 18">
            <div>
              任务说明：用户邀请好友成功入会，可获取{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}；
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 7">
            <div>
              任务说明：用户可参与入会任务，增加{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}。
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 20">
            <div>
              任务说明：用户成功预定预售商品且支付定金可以获取{{ mainText
              }}{{ isShowUnit ? "机会" : "" }};
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 23">
            <div>
              任务说明：此任务可以放搜索关键词，用户进入活动点击去搜索自动带【关键词】跳转至APP查询页查询；
            </div>
          </jd-tip>
        </div>
        <el-form-item label="任务有效期:" required>
          <div class="task-wrap">
            <div class="task-wrap-radio">
              <el-radio
                :disabled="isNeedDisabled(taskForm) && taskForm.type == 20"
                v-model="taskForm.taskTime"
                :label="1"
                >长期有效</el-radio
              >
              <el-radio
                :disabled="isNeedDisabled(taskForm) && taskForm.type == 20"
                v-model="taskForm.taskTime"
                :label="2"
                >指定日期</el-radio
              >
            </div>
            <div class="my_select_time" v-if="taskForm.taskTime == 2">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="taskForm.startTime"
                type="date"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
                :disabled="isNeedDisabled(taskForm) && taskForm.type == 20"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="taskForm.endTime"
                type="date"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time2"
                :picker-options="optionsValueEnd"
                :disabled="isNeedDisabled(taskForm) && taskForm.type == 20"
                :clearable="false"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart"
                @click="clearTaskTime()"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="邀请人数上限:" required v-if="taskForm.type == 8">
          <span>
            <el-input
              v-model.number="taskForm.inviteLimit"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.inviteLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
          </span>
          人
        </el-form-item>
        <el-form-item label="跳转链接:" required v-if="taskForm.type == 5">
          <el-input
            v-model="taskForm.jumpUrl"
            placeholder="请输入跳转链接"
          ></el-input>
          <div>
            <span class="tip-red">注：跳转的链接必须为京东链接</span>
          </div>
        </el-form-item>
        <template v-if="taskForm.type == 17">
          <el-form-item label="奖励规则:" required>
            <el-select
              v-model="taskForm.giveType"
              :disabled="isNeedDisabled(taskForm)"
              style="width: 200px"
              @change="giveTypeChange"
            >
              <el-option
                v-for="item in rewardRulesOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-tooltip
              class="item"
              effect="light"
              placement="right"
              style="margin-left: 8px"
            >
              <div slot="content">
                1、按固定次数赠送{{ mainText
                }}{{ isShowUnit ? "机会" : "" }}：例如设置【满10元及以上赠送1{{
                  otherUnit ? otherUnit : unit
                }}{{
                  isShowUnit ? "机会" : ""
                }}】，若用户下单100元，则也只赠送1{{
                  otherUnit ? otherUnit : unit
                }}{{ isShowUnit ? "机会" : "" }}；
                <br />
                2、按倍数赠送{{ mainText
                }}{{
                  isShowUnit ? "机会" : ""
                }}：例如设置【每满100元及以上赠送1{{
                  otherUnit ? otherUnit : unit
                }}{{
                  isShowUnit ? "机会" : ""
                }}】，若按单笔，则用户第一次下单90元，则未达到赠送条件，第二次下单110元，则赠送1{{
                  otherUnit ? otherUnit : unit
                }}{{ isShowUnit ? "机会" : "" }}；
                <br />
                若按累计，则用户第一次下单90元，未达到赠送条件；第二次下单110元，两笔订单合起来为200元，则赠送2{{
                  otherUnit ? otherUnit : unit
                }}{{ isShowUnit ? "机会" : "" }}
                <br />
                3、按阶梯赠送{{ mainText
                }}{{
                  isShowUnit ? "机会" : ""
                }}：例如设置多阶梯【满10元及以上赠送1{{
                  otherUnit ? otherUnit : unit
                }}{{ isShowUnit ? "机会" : "" }}，满30元及以上赠送3{{
                  otherUnit ? otherUnit : unit
                }}{{
                  isShowUnit ? "机会" : ""
                }}】，若按单笔，用户第一次下单10元，则赠送1{{
                  otherUnit ? otherUnit : unit
                }}{{
                  isShowUnit ? "机会" : ""
                }}，第二次下单20元，满足“满10元未达到30元”，则赠送1{{
                  otherUnit ? otherUnit : unit
                }}{{ isShowUnit ? "机会" : "" }}
                <br />
                若按累计，用户下单10元，则本次赠送1{{
                  otherUnit ? otherUnit : unit
                }}{{
                  isShowUnit ? "机会" : ""
                }}，该用户再次下单20元，此时满足第二个阶梯30元，但是由于已经赠送了1{{
                  otherUnit ? otherUnit : unit
                }}{{ isShowUnit ? "机会" : "" }}，所以再次赠送2{{
                  otherUnit ? otherUnit : unit
                }}{{ isShowUnit ? "机会" : "" }}。达到满30元赠送3{{
                  otherUnit ? otherUnit : unit
                }}{{ isShowUnit ? "机会" : "" }}的设置。
                <br />
              </div>
              <div
                style="
                  display: inline-flex;
                  cursor: pointer;
                  align-items: center;
                "
              >
                奖励规则说明<i
                  class="el-icon-question"
                  style="color: #ccc; margin-left: 2px"
                ></i>
              </div>
            </el-tooltip>
            <div class="rule_box">
              <el-form-item label="下单店铺:" required>
                <orderShopCom
                  :venderIds.sync="taskForm.venderIds"
                  :isCreated="isCreated"
                  :multiShopGoods.sync="multiShopGoods"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                />
              </el-form-item>
              <el-form-item label="下单时间:" required>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderStartTime"
                    :picker-options="taskstartpickerOptionsValue"
                    type="datetime"
                    placeholder="开始日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 148px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderEndTime"
                    :picker-options="buyTaskpickerOptionsValueEnd"
                    type="datetime"
                    placeholder="结束日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    default-time="23:59:59"
                    style="width: 152px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    v-if="!activityData.isStart"
                    @click="clearOrderTime()"
                  ></i>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  />
                </div>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="最长时间跨度不超过90天"
                  placement="bottom"
                  style="margin-left: 8px"
                >
                  <div
                    style="width: 35px; display: inline-flex; cursor: pointer"
                  >
                    <i class="el-icon-question" style="color: #ccc"></i>
                  </div>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="金额统计类型:" required>
                <el-radio-group
                  v-model="taskForm.orderPaymentType"
                >
                  <el-radio :label="1">
                    <span>订单金额（后台价）</span>
                    <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="0" v-if="!isVenderType">
                    <span>用户应付金额</span>
                    <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="2" v-if="!isVenderType">
                    <span>用户实付金额</span>
                    <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="商品要求:" required>
                <!-- <el-radio v-model="taskForm.skuType" :label="0"
                  >全部商品</el-radio
                >
                <el-radio v-model="taskForm.skuType" :label="1"
                  >指定商品</el-radio
                >
                <div style="display: inline-block">
                  <jd-button
                    type="blue"
                    @click="showGoods(100)"
                    :disabled="taskForm.skuType != 1"
                    >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
                  >
                </div> -->
                <productReqCom
                  :filterType.sync="taskForm.skuType"
                  :venderIds.sync="taskForm.venderIds"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                  :multiShopGoods.sync="multiShopGoods"
                  :isShowExclude="false"
                  :limitNum="goodsLimit"
                  addGoodText="选择商品"
                />
              </el-form-item>
              <!-- 指定商品规则：仅商品要求为"指定商品"时展示，0=整单计算 1=仅统计指定商品金额和件数 -->
              <el-form-item label="指定商品规则:" v-if="taskForm.orderPaymentType==1&&taskForm.skuType == 1">
                <el-select style="width: 280px;" v-model="taskForm.statsSkuType" placeholder="">
                  <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                  <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="订单金额:"
                v-if="taskForm.giveType == 0"
                required
              >
                大于等于<el-input
                  class="input-w ml8 mr8"
                  v-model="taskForm.amtLimit"
                  placeholder="请输入"
                  @input="validateInput"
                />元
              </el-form-item>
              <el-form-item label="商品件数:" v-if="taskForm.giveType == 0">
                大于等于<el-input
                  class="input-w ml8 mr8"
                  v-model="taskForm.itemTotalLimit"
                  placeholder="请输入"
                  @input="validateInputNew"
                />件
              </el-form-item>
              <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                <el-radio-group
                  v-model="taskForm.mergeOrder"
                >
                  <el-radio :label="false">否</el-radio>
                  <el-radio :label="true">是</el-radio>
                </el-radio-group>
                <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
              </el-form-item>
              <el-form-item label="订单状态:" required>
                <el-radio v-model="taskForm.orderType" :label="0"
                  >已付款</el-radio
                >
                <el-radio v-model="taskForm.orderType" :label="1"
                  >已完成</el-radio
                >
              </el-form-item>
              <el-form-item label="统计方式:" required>
                <el-radio
                  v-model="taskForm.orderCountType"
                  @change="taskForm.countType = 1"
                  :label="1"
                  @input="taskForm.condition2 = ''"
                  >累计订单</el-radio
                >
                <el-radio
                  v-model="taskForm.orderCountType"
                  @change="taskForm.countType = 1"
                  :label="0"
                  @input="taskForm.condition2 = ''"
                  >单笔订单</el-radio
                >
              </el-form-item>
              <el-form-item
                label="统计类型："
                v-if="taskForm.giveType == 1 || taskForm.giveType == 2"
                required
              >
                <el-radio
                  @change="countTypeChange"
                  v-model="taskForm.countType"
                  :label="1"
                  >按订单金额</el-radio
                >
                <el-radio
                  @change="countTypeChange"
                  v-model="taskForm.countType"
                  :label="2"
                  >按商品件数</el-radio
                >
                <el-radio
                  @change="countTypeChange"
                  v-if="taskForm.orderCountType == 1"
                  v-model="taskForm.countType"
                  :label="3"
                  >按订单笔数</el-radio
                >
              </el-form-item>
              <el-form-item label="任务条件:" required>
                <span
                  v-if="taskForm.orderCountType == 0 && taskForm.giveType == 0"
                >
                  每1个订单赠送1{{ unit }}{{ mainText
                  }}{{ isShowUnit ? "机会" : "" }}
                </span>
                <span
                  v-else-if="
                    taskForm.orderCountType == 1 && taskForm.giveType == 0
                  "
                >
                  完成任务赠送1{{ unit }}{{ mainText
                  }}{{ isShowUnit ? "机会" : "" }}
                </span>
                <span v-else-if="taskForm.giveType == 1">
                  <div
                    v-for="(item, index) in taskLevelList"
                    :key="index"
                    style="margin-bottom: 6px"
                  >
                    <span v-if="taskForm.countType == 1"
                      >每满<el-input
                        placeholder="请输入金额"
                        v-model="item.limit"
                        style="width: 110px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInput(e);
                          }
                        "
                      />元</span
                    >
                    <span v-if="taskForm.countType == 2"
                      >每满<el-input
                        placeholder="请输入件数"
                        v-model="item.limit"
                        style="width: 110px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />件</span
                    >
                    <span v-if="taskForm.countType == 3"
                      >每满<el-input
                        placeholder="请输入笔数"
                        v-model="item.limit"
                        style="width: 110px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />笔</span
                    >
                    ，赠送
                    <el-input
                      v-model.number="item.giveNum"
                      placeholder="请输入次数"
                      style="width: 110px"
                      @input="
                        item.giveNum = getNumberData(1, $event, 0, 1, 999)
                      "
                    ></el-input>
                    {{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
                  </div>
                </span>
                <span v-else-if="taskForm.giveType == 2">
                  <div
                    v-for="(item, index) in taskLevelList"
                    :key="index"
                    style="margin-bottom: 6px"
                  >
                    <span v-if="taskForm.countType == 1"
                      >每满<el-input
                        placeholder="请输入金额"
                        v-model="item.limit"
                        @change="
                          (e) => {
                            item.limit = NumChange(e, 'limit', index);
                          }
                        "
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInput(e);
                          }
                        "
                      />元</span
                    >
                    <span v-if="taskForm.countType == 2"
                      >每满<el-input
                        placeholder="请输入件数"
                        v-model="item.limit"
                        @change="
                          (e) => {
                            item.limit = NumChange(e, 'limit', index);
                          }
                        "
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />件</span
                    >
                    <span v-if="taskForm.countType == 3"
                      >每满<el-input
                        placeholder="请输入笔数"
                        v-model="item.limit"
                        @change="
                          (e) => {
                            item.limit = NumChange(e, 'limit', index);
                          }
                        "
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />笔</span
                    >
                    ，赠送
                    <el-input
                      v-model.number="item.giveNum"
                      @change="
                        (e) => {
                          item.giveNum = NumChange(e, 'giveNum', index);
                        }
                      "
                      placeholder="请输入次数"
                      style="width: 95px"
                      @input="
                        item.giveNum = getNumberData(1, $event, 0, 1, 999)
                      "
                    ></el-input>
                    {{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
                    <span
                      v-if="index >= 2"
                      @click="delTaskLevel(index)"
                      style="cursor: pointer"
                      ><i class="el-icon-error"></i
                    ></span>
                  </div>
                  <jd-button
                    :disabled="taskLevelList.length >= 5"
                    style="margin-right: 8px"
                    @click="addTaskLevel"
                    >添加阶梯({{ taskLevelList.length }}/5)</jd-button
                  >
                </span>
              </el-form-item>
              <el-form-item label="任务次数:" required>
                <span
                  v-if="taskForm.orderCountType == 0 && taskForm.giveType == 0"
                >
                  活动期间最多完成
                  <el-input
                    v-model.number="taskForm.condition2"
                    placeholder="请输入"
                    class="input-w"
                    @input="
                      taskForm.condition2 = getNumberData(1, $event, 0, 1, 999)
                    "
                  ></el-input>
                  {{ unit }}
                </span>
                <span
                  v-else-if="taskForm.giveType == 1 || taskForm.giveType == 2"
                >
                  <el-radio v-model="taskForm.taskDoType" :label="0"
                    >不限制次数</el-radio
                  >
                  <el-radio v-model="taskForm.taskDoType" :label="1"
                    >限制次数</el-radio
                  >
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="`限制该任务可获得${mainText}次数上限`"
                    placement="bottom"
                    style="margin-left: 8px"
                  >
                    <div
                      style="width: 35px; display: inline-flex; cursor: pointer"
                    >
                      <i class="el-icon-question" style="color: #ccc"></i>
                    </div>
                  </el-tooltip>
                  <div v-if="taskForm.taskDoType == 1">
                    活动期间最多获得<el-input
                      v-model.number="taskForm.condition2"
                      placeholder="请输入"
                      class="input-w"
                      @input="
                        taskForm.condition = getNumberData(1, $event, 0, 1, 999)
                      "
                    ></el-input
                    >{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
                  </div>
                </span>
                <span v-else>{{ taskForm.count }}</span>
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <el-form-item
          label="奖励规则:"
          v-else-if="taskForm.type == 20"
          required
        >
          <el-radio-group
            v-model="taskForm.countType"
            :disabled="isNeedDisabled(taskForm)"
            @change="handleCountTypeChange"
          >
            <el-radio :label="2"
              >按商品件数赠送{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}</el-radio
            >
            <el-radio :label="3"
              >按订单笔数赠送{{ mainText
              }}{{ isShowUnit ? "机会" : "" }}</el-radio
            >
          </el-radio-group>
          <div class="rule_box">
            <el-form-item label="下单时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.orderStartTime"
                  :picker-options="taskstartpickerOptionsValue"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 148px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="isNeedDisabled(taskForm)"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.orderEndTime"
                  :picker-options="taskpickerOptionsValueEnd"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  default-time="23:59:59"
                  style="width: 152px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                  :disabled="isNeedDisabled(taskForm)"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  v-if="!activityData.isStart"
                  @click="clearOrderTime()"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <el-form-item label="商品要求：" required class="skuType-label">
              <el-radio
                v-model="taskForm.skuType"
                :label="0"
                :disabled="isNeedDisabled(taskForm)"
                >全部商品</el-radio
              >
              <el-radio
                v-model="taskForm.skuType"
                :label="1"
                :disabled="isNeedDisabled(taskForm)"
                >指定商品</el-radio
              >
              <el-radio
                v-model="taskForm.skuType"
                :label="2"
                :disabled="isNeedDisabled(taskForm)"
                >排除商品</el-radio
              >
              <div style="display: inline-block">
                <jd-button
                  type="blue"
                  @click="showGoods(100)"
                  :disabled="taskForm.skuType == 0"
                  >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
                >
              </div>
              <div class="tip-box">
                注:指定商品务必是预售商品，否则用户购买指定商品非预售商品将无法完成任务
              </div>
            </el-form-item>
            <!-- 指定商品规则：仅商品要求为"指定商品"时展示，0=整单计算 1=仅统计指定商品金额和件数 -->
            <el-form-item label="指定商品规则:" v-if="taskForm.skuType == 1">
              <el-select style="width: 280px;" v-model="taskForm.statsSkuType" :disabled="isNeedDisabled(taskForm)" placeholder="">
                <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务条件:" required>
              <div v-for="(item, index) in taskOrderList" :key="index">
                <span> 每下单 </span>
                <el-input
                  placeholder="请输入"
                  :disabled="isNeedDisabled(taskForm)"
                  v-model="item.limit"
                  @change="
                    (e) => {
                      item.limit = NumChange2(e, 'limit', index);
                    }
                  "
                  style="width: 95px; margin: 0 8px"
                  @input="
                    (e) => {
                      item.limit = inputValidateInputNew(e);
                    }
                  "
                />
                <span
                  >{{ taskForm.countType == 2 ? "件商品" : "笔订单" }}获取</span
                >
                <el-input
                  v-model.number="item.giveNum"
                  :disabled="isNeedDisabled(taskForm)"
                  @change="
                    (e) => {
                      item.giveNum = NumChange2(e, 'giveNum', index);
                    }
                  "
                  placeholder="请输入"
                  style="width: 95px; margin-left: 8px"
                  @input="item.giveNum = getNumberData(1, $event, 0, 1, 999)"
                ></el-input
                ><span class="ml8"
                  >{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}</span
                >
              </div>
            </el-form-item>
            <el-form-item label="任务次数:" required>
              <span class="mr8">活动期间最多获取</span>
              <el-input
                v-model.number="taskForm.condition2"
                placeholder="请输入"
                style="width: 95px"
                :disabled="isNeedDisabled(taskForm)"
                @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
              ></el-input>
              <span class="ml8">次</span>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item
          label="任务条件:"
          v-if="taskForm.type != 17 && taskForm.type != 20"
          required
        >
          <span v-if="taskForm.type == 13">
            成功浏览
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
          </span>
          <span v-else-if="taskForm.type == 4">
            成功加购
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
          </span>
          <span v-else-if="taskForm.type == 9">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次商品，赠送1{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
          </span>
          <span v-else-if="taskForm.type == 10">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次店铺，赠送1{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
          </span>
          <span v-else-if="taskForm.type == 11">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次活动，赠送1{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
          </span>
          <span v-else-if="taskForm.type == 12">
            每成功预约
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
          </span>
          <span v-else-if="taskForm.type == 16">
            每
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            积分可兑换1{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
          </span>
          <span v-else-if="taskForm.type == 18">
            每成功邀请
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            个好友入会，赠送1{{ unit }}{{ mainText
            }}{{ isShowUnit ? "机会" : "" }}
          </span>
          <div v-else-if="taskForm.type == 5" class="flexc-cen-x">
            <span>每成功浏览当前链接</span>
            <el-input
              class="ml8"
              style="width: 100px"
              v-model="taskForm.viewTime"
              @input="taskForm.viewTime = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8 mr8">秒，赠送</span>
            <el-input
              style="width: 100px"
              v-model="taskForm.giveLimit"
              @input="taskForm.giveLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8"
              >{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}</span
            >
          </div>
          <span v-else-if="taskForm.type == 23">
            成功查询关键词，赠送1{{ unit }}{{ mainText
            }}{{ isShowUnit ? "机会" : "" }}
          </span>
          <span v-else>{{ taskForm.condition }}</span>
        </el-form-item>
        <el-form-item label="浏览商品:" required v-if="taskForm.type == 13">
          <jd-button type="blue" @click="showGoods(100)"
            >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="搜索关键词:"
          v-if="taskForm.type == 23"
          label-width="110px"
          required
        >
          <el-input
            style="width: 320px"
            v-model="taskForm.searchKeyword"
            show-word-limit
            maxlength="128"
            placeholder="请输入搜索关键词，例【橙汁】"
          ></el-input>
        </el-form-item>
        <el-form-item label="加购商品:" required v-if="taskForm.type == 4">
          <jd-button type="blue" @click="showGoods(100)"
            >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
          >
        </el-form-item>
        <el-form-item label="分享商品:" required v-if="taskForm.type == 9">
          <jd-button type="blue" @click="showGoods(1)"
            >选择商品（{{ taskForm.skuIds.length }}/1）</jd-button
          >
        </el-form-item>
        <el-form-item label="预约商品:" required v-if="taskForm.type == 12">
          <div class="book-good-wrap">
            <jd-button type="blue" @click="showGoods(100)"
              >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
            >
            <span class="tip-red" style="margin-left: 10px"
              >注意：请添加预约商品，非预约商品无法完成任务</span
            >
          </div>
        </el-form-item>
        <el-form-item
          label="任务次数:"
          v-if="taskForm.type != 17 && taskForm.type != 20"
          required
        >
          <span v-if="taskForm.type == 12">
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 8">
            {{
              `活动期间内最多完成${
                taskForm.inviteLimit ? taskForm.inviteLimit : 0
              }次`
            }}
          </span>
          <span v-else-if="taskForm.type == 16">
            <el-select v-model="taskForm.activityType" placeholder="请选择">
              <el-option label="活动期间" :value="2"></el-option>
              <el-option label="每日" :value="1"></el-option>
            </el-select>
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 18">
            活动期间最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              class="input-w"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else>{{ taskForm.count }}</span>
        </el-form-item>
        <el-form-item
          :label="`${mainText}${isShowUnit ? '机会' : ''}:`"
          v-if="taskForm.type == 7"
          required
        >
          <div>
            加入会员可获取<el-input
              v-model.number="taskForm.giveLimit"
              placeholder="请输入"
              class="input-w ml8 mr8"
              @input="taskForm.giveLimit = getNumberData(1, $event, 0, 1, 999)"
            ></el-input
            >{{ unit }}{{ mainText }}{{ isShowUnit ? "机会" : "" }}
          </div>
        </el-form-item>
      </el-form>
    </jd-dialog>
    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="goodsState"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="goodsLimit"
      :isShow="goodsState"
      :moduleType="true"
      :selectGoods="selectGoodsSkuList"
      :hasSelectGoods="hasSelectGoods"
      :isClear="activityData.isStart"
      @close="selectGoodsChange"
    ></select-goods>
  </div>
</template>

<script>
import SelectGoods from "@/components/selectGoodsMonitor2";
import orderShopCom from "../multipleStoreSetting/orderShopCom.vue";
import productReqCom from "../multipleStoreSetting/productReqCom.vue";
import {
  conditionValue,
  getRewardRulesOptions,
  getTaskTypeOptions,
} from "../taskCommonField/index.js";
import { useValidateMultiShopGoods } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
export default {
  components: {
    SelectGoods,
    orderShopCom,
    productReqCom,
  },
  props: {
    activityData: {
      type: Object,
      default: () => {},
    },
    addTaskBtnText: {
      type: String,
      default: "+添加任务",
    },
    activityStartTime: {
      type: String,
      default: "",
    },
    activityEndTime: {
      type: String,
      default: "",
    },
    // 预售下单进行中的活动可以修改指定商品，但是已选的不可以删除
    hasSelectGoods: {
      type: Array,
      default: () => [],
    },
    mainText: {
      type: String,
      default: "抽奖",
    },
    taskList: {
      type: Array,
      default: () => [],
    },
    taskOrders: {
      type: Array,
      default: () => [],
    },
    // 开启进行中的活动是否支持修改
    isDisabled: {
      type: Boolean,
      default: false,
    },
    copyTaskList: {
      type: Array,
      default: () => [],
    },
    // 额外提示
    extraText: {
      type: String,
      default: "",
    },
    isShowUnit: {
      type: Boolean,
      default: true,
    },
    unit: {
      type: String,
      default: "次",
    },
    copySteList: {
      type: Array,
      default: () => [],
    },
    // 进行中活动是否允许修改任务
    isTrueEdit: {
      type: Boolean,
      default: false,
    },
    // 显示自定义列
    isShowCustom: {
      type: Boolean,
      default: false,
    },
    // 如果有值，优先使用otherUnit，否则使用unit
    otherUnit: {
      type: String,
      default: "",
    },
    // 开榜时间
    openingTime: {
      type: String,
      default: "",
    },
  },
  watch: {
    copySteList: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.taskLevelList = JSON.parse(JSON.stringify(newVal));
        }
      },
      immediate: true,
      deep: true,
    },
    taskOrders: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.taskOrderList = JSON.parse(JSON.stringify(newVal));
        }
      },
      immediate: true,
      deep: true,
    },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.taskForm.orderPaymentType = 1
      } 
    },
  },
  data() {
    return {
      isCreated: false,
      goodsLimit: 100,
      goodsState: false,
      taskRow: {},
      isTaskEdit: false,
      taskDialog: false,
      taskIsLook: false,
      taskDateList: [],
      taskForm: {
        giveType: 0,
        countType: 1,
        taskDoType: 0,
        type: 1,
        taskTime: 1,
        condition: null,
        condition2: null,
        count: null,
        endTime: null,
        startTime: null,
        skuIds: [],
        selectGoodsSkuList: [],
        inviteLimit: null,
        jumpUrl: null,
        activityType: 2,
        skuType: 0,
        statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
        orderType: 0,
        orderCountType: 1,
        itemTotalLimit: null,
        amtLimit: null,
        orderEndTime: null,
        orderStartTime: null,
        venderIds: [],
        sellerSkuList: [],
      },
      multiShopGoods: [],
      selectGoodsSkuList: [],
      conditionValue: conditionValue,
      goodsTypeList: [13, 4, 9, 12],
      goodsLimitList: [13, 4, 12],
      taskLevelList: [],
      taskstartpickerOptionsValue: {
        disabledDate: (time) => {
          const endTime = this.taskForm.orderEndTime
            ? new Date(this.taskForm.orderEndTime).getTime() -
              1 * 24 * 60 * 60 * 1000
            : null;
          const maxStartTime = endTime
            ? endTime - 90 * 24 * 60 * 60 * 1000
            : null;
          return (
            (endTime && time.getTime() > endTime) ||
            (maxStartTime && time.getTime() < maxStartTime)
          );
        },
      },
      taskpickerOptionsValueEnd: {
        disabledDate: (time) => {
          const startTime = this.taskForm.orderStartTime
            ? new Date(this.taskForm.orderStartTime).getTime() +
              1 * 24 * 60 * 60 * 1000
            : null;
          const maxEndTime = startTime
            ? startTime + 89 * 24 * 60 * 60 * 1000
            : null;
          return (
            (startTime && time.getTime() < startTime) ||
            (maxEndTime && time.getTime() > maxEndTime)
          );
        },
      },
      buyTaskpickerOptionsValueEnd: {
        disabledDate: (time) => {
          const startTime = this.taskForm.orderStartTime
            ? new Date(this.taskForm.orderStartTime).getTime() +
              1 * 24 * 60 * 60 * 1000
            : null;
          const maxEndTime = startTime
            ? startTime + 89 * 24 * 60 * 60 * 1000
            : null;

          let isAfterOpeningDay = false;
          if (this.openingTime) {
            const openingDay = new Date(this.openingTime);
            openingDay.setHours(0, 0, 0, 0);
            const nextDay = openingDay.getTime() + 8.64e7;
            isAfterOpeningDay = time.getTime() >= nextDay;
          }

          return (
            (startTime && time.getTime() < startTime) ||
            (maxEndTime && time.getTime() > maxEndTime) ||
            isAfterOpeningDay
          );
        },
      },
      optionsValueEnd: {
        disabledDate: (time) => {
          const startTime = this.taskForm.startTime
            ? new Date(this.taskForm.startTime).getTime() -
              1 * 24 * 60 * 60 * 1000
            : null;
          return startTime && time.getTime() < startTime;
        },
      },
      taskOrderList: [],
    };
  },
  computed: {
    taskDataList: {
      get() {
        return this.taskList;
      },
      set(val) {
        this.$emit("update:taskList", val);
      },
    },
    // 获取任务次数
    getCount() {
      return (item) => {
        const {
          type,
          count,
          inviteLimit,
          condition2,
          activityType,
          orderCountType,
        } = item;
        let str = count;
        if (type == 12) {
          str = `活动期间最多完成${condition2}次`;
        } else if (type == 8) {
          str = `活动期间最多完成${inviteLimit}次`;
        } else if (type == 16) {
          str = `${
            activityType == 2 ? "活动期间" : "活动期间每日"
          }最多完成${condition2}次`;
        } else if (type == 17 && item.giveType == 0) {
          str = `活动期间最多完成${orderCountType == 0 ? condition2 : "1"}次`;
        } else if (type == 17 && item.giveType != 0) {
          str =
            item.taskDoType == 0
              ? "活动期间不限次数"
              : `活动期间最多获得${item.condition2}${this.unit}${
                  this.mainText
                }${this.isShowUnit ? "机会" : ""}`;
        } else if (type == 18) {
          str = `活动期间最多完成${condition2}次`;
        } else if (type == 20) {
          str = `活动期间最多获取${condition2}${this.unit}${this.mainText}${
            this.isShowUnit ? "机会" : ""
          }`;
        }
        return str;
      };
    },
    // 获取任务条件
    getCondition() {
      return (item) => {
        const { type, condition, condition2, orderCountType } = item;
        let str = condition;
        if (type == 13) {
          str = `成功浏览${condition}件商品，赠送1${this.unit}${this.mainText}${
            this.isShowUnit ? "机会" : ""
          }`;
        } else if (type == 4) {
          str = `成功加购${condition}件商品，赠送1${this.unit}${this.mainText}${
            this.isShowUnit ? "机会" : ""
          }`;
        } else if (type == 9) {
          str = `成功分享${condition}次商品，赠送1${this.unit}${this.mainText}${
            this.isShowUnit ? "机会" : ""
          }`;
        } else if (type == 10) {
          str = `成功分享${condition}次店铺，赠送1${this.unit}${this.mainText}${
            this.isShowUnit ? "机会" : ""
          }`;
        } else if (type == 11) {
          str = `成功分享${condition}次活动，赠送1${this.unit}${this.mainText}${
            this.isShowUnit ? "机会" : ""
          }`;
        } else if (type == 12) {
          str = `每成功预约${condition}件商品，赠送1${this.unit}${
            this.mainText
          }${this.isShowUnit ? "机会" : ""}`;
        } else if (type == 16) {
          str = `每${condition}积分可兑换1${this.unit}${this.mainText}${
            this.isShowUnit ? "机会" : ""
          }`;
        } else if (type == 17) {
          if (item.giveType == 0) {
            str =
              orderCountType == 0
                ? `每1个订单赠送1${this.unit}${this.mainText}${
                    this.isShowUnit ? "机会" : ""
                  }`
                : `完成任务赠送1${this.unit}${this.mainText}${
                    this.isShowUnit ? "机会" : ""
                  }`;
          } else if (item.giveType == 1) {
            this.taskLevelList.forEach((it) => {
              str = `购买商品，每满${
                item.countType == 1
                  ? it.limit + "元"
                  : item.countType == 2
                  ? it.limit + "件"
                  : item.countType == 3
                  ? it.limit + "笔"
                  : ""
              }可赠送${it.giveNum}${this.unit}${this.mainText}${
                this.isShowUnit ? "机会" : ""
              }`;
            });
          } else if (item.giveType == 2) {
            str = `购买商品：`;
            this.taskLevelList.forEach((it) => {
              str =
                str +
                `\n满${
                  item.countType == 1
                    ? it.limit + "元"
                    : item.countType == 2
                    ? it.limit + "件"
                    : item.countType == 3
                    ? it.limit + "笔"
                    : ""
                }可赠送${it.giveNum}${this.unit}${this.mainText}${
                  this.isShowUnit ? "机会" : ""
                }；`;
            });
          }
        } else if (type == 18) {
          str = `成功邀请好友入会${condition}次，赠送1${this.unit}${
            this.mainText
          }${this.isShowUnit ? "机会" : ""}`;
        } else if (type == 20) {
          this.taskOrderList.forEach((it) => {
            str = `成功下单并支付定金，每满${
              item.countType == 2 ? it.limit + "件" : it.limit + "笔"
            }可赠送${it.giveNum}${this.unit}${this.mainText}${
              this.isShowUnit ? "机会" : ""
            }`;
          });
        } else if (type == 5) {
          str = `成功浏览会场${item.viewTime || 1}秒，赠送${
            item.giveLimit || 1
          }${this.unit}${this.mainText}${this.isShowUnit ? "机会" : ""}`;
        } else if (type == 23) {
          str = `成功查询关键词，赠送1${this.unit}${this.mainText}${
            this.isShowUnit ? "机会" : ""
          }`;
        }
        return str;
      };
    },
    // 获取任务类型
    getTaskType() {
      return (type) => {
        const obj = this.taskTypeOptions.find((item) => item.value == type);
        return obj.label;
      };
    },
    taskTypeOptions() {
      return getTaskTypeOptions(this.mainText, this.isShowUnit, this.unit);
    },
    // 活动进行中/未开始
    isNeedDisabled() {
      return (row) => {
        if (this.activityData.isStart && !this.isTaskEdit) {
          return false;
        } else if (this.activityData.isStart && !row.isAdd && this.isTaskEdit) {
          return true;
        }
      };
    },
    // 获取奖励规则
    rewardRulesOptions() {
      return getRewardRulesOptions(
        this.firstText ? this.firstText : this.mainText
      );
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    isVenderType() {
      return this.multiShopGoods.some((item) => item.venderType);
    },
  },
  methods: {
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    initData() {
      this.taskForm.venderIds = this.taskForm.venderIds&&this.taskForm.venderIds.length> 0 ? this.taskForm.venderIds : [this.venderId];
      this.taskForm.sellerSkuList = this.taskForm.sellerSkuList&&this.taskForm.sellerSkuList.length> 0 ? this.taskForm.sellerSkuList : [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, this.taskForm.venderIds);
    },
    isMonotonicIncreasing(arr) {
      return arr.every((value, index, array) => {
        return index === 0 || parseFloat(value) > parseFloat(array[index - 1]);
      });
    },
    // 确认添加任务
    sureTask() {
      // 任务有效期
      if (this.taskForm.taskTime == 2) {
        if (!this.taskForm.startTime || !this.taskForm.startTime) {
          return this.$message.warning("请填写任务有效期");
        }
        if (this.taskForm.startTime && this.taskForm.endTime) {
          const startTime = new Date(
            this.taskForm.startTime + " 23:59:59"
          ).getTime();
          const endTime = new Date(
            this.taskForm.endTime + " 00:00:00"
          ).getTime();
          const activityStartTime = new Date(this.activityStartTime).getTime();
          const activityEndTime = new Date(this.activityEndTime).getTime();
          if (startTime > endTime) {
            return this.$message.warning("结束时间不能小于开始时间");
          }
          if (activityStartTime > startTime || endTime > activityEndTime) {
            return this.$message.warning(
              "任务有效期超出了活动时间范围，请重新选择"
            );
          }
        }
      }
      // 邀请人数上限
      if (this.taskForm.type == 8) {
        if (!this.taskForm.inviteLimit) {
          return this.$message.warning("请填写邀请人数上限");
        }
      }
      // 跳转链接
      if (this.taskForm.type == 5) {
        if (!this.taskForm.jumpUrl) {
          return this.$message.warning("请填写跳转链接");
        }
        if (!this.taskForm.viewTime) {
          return this.$message.warning("请输入浏览时间");
        }
        if (!this.taskForm.giveLimit) {
          return this.$message.warning("请输入抽奖次数");
        }
      }
      // 查询关键词
      if (this.taskForm.type == 23) {
        if (!this.taskForm.searchKeyword) {
          return this.$message.warning("请输入查询关键词");
        }
      }
      // 购买商品类型
      if (this.taskForm.type == 17) {
        // 下单时间-------------
        if (!this.taskForm.orderStartTime || !this.taskForm.orderEndTime) {
          return this.$message.warning("请填写下单时间");
        }
        if (this.taskForm.orderStartTime && this.taskForm.orderEndTime) {
          const startTime = new Date(
            this.taskForm.orderStartTime + " 00:00:00"
          ).getTime();
          const endTime = new Date(
            this.taskForm.orderEndTime + " 00:00:00"
          ).getTime();
          if (startTime > endTime) {
            return this.$message.warning("下单结束时间不能小于下单开始时间");
          }
        }
        if (this.openingTime) {
          if (this.taskForm.orderEndTime) {
            const endTime = new Date(this.taskForm.orderEndTime).getTime();
            const latestEndTime =
              new Date(this.openingTime).getTime() - 30 * 60 * 1000;
            if (endTime > latestEndTime) {
              return this.$message.warning(
                "下单结束时间需早于开榜时间至少30分钟~"
              );
            }
          }
        }
        // 订单金额-------------
        if (!this.taskForm.amtLimit && this.taskForm.giveType == 0) {
          return this.$message.warning("请填写订单金额");
        }
        // 指定商品-------------
        // if (
        //   this.taskForm.skuType == 1 &&
        //   (!this.taskForm.skuIds.length || this.taskForm.skuIds.length < 1)
        // ) {
        //   return this.$message.warning("请选择指定商品");
        // }
        if (this.taskForm.skuType == 1) {
          const obj = this.taskForm.sellerSkuList.find((item) => {
            return item.skuIds.length == 0;
          });
          if (obj) {
            const shop = this.multiShopGoods.find((item) => {
              return item.venderId == obj.venderId;
            });
            return this.$message.warning(`请选择${shop.shopTitle}的指定商品`);
          }
        }
        if (this.taskForm.giveType == 1 || this.taskForm.giveType == 2) {
          let isLimit = false;
          let isLimitZero = false;
          this.taskLevelList.forEach((item) => {
            if (!item.limit || !item.giveNum) {
              isLimit = true;
            }
            if (item.limit == 0 && item.limit != "") {
              isLimitZero = true;
            }
          });
          if (isLimitZero) {
            return this.$message.warning("任务条件值需大于0");
          }
          if (isLimit) {
            return this.$message.warning("请填写任务条件");
          }
          if (!this.taskForm.condition2 && this.taskForm.taskDoType == 1) {
            return this.$message.warning("请填写任务次数");
          }
        }
        // 单笔订单-任务次数
        if (
          this.taskForm.orderCountType == 0 &&
          !this.taskForm.condition2 &&
          this.taskForm.giveType == 0
        ) {
          return this.$message.warning("请填写任务次数");
        }

        if (this.taskForm.giveType == 2) {
          let limitArr = [];
          let giveNumArr = [];
          this.taskLevelList.forEach((item) => {
            limitArr.push(item.limit);
            giveNumArr.push(item.giveNum);
          });
          if (!this.isMonotonicIncreasing(limitArr)) {
            return this.$message.warning("高级阶梯笔数需大于低级阶梯笔数");
          }
          if (!this.isMonotonicIncreasing(giveNumArr)) {
            this.$message.warning(
              `高级阶梯${this.mainText}${
                this.isShowUnit ? "机会" : ""
              }需大于低级阶梯${this.mainText}${this.isShowUnit ? "机会" : ""}`
            );
            return;
          }
        }
        if (
          (this.taskForm.giveType == 1 || this.taskForm.giveType == 2) &&
          this.taskForm.taskDoType == 1
        ) {
          let number = 0;
          this.taskLevelList.forEach((item) => {
            number = Number(item.giveNum) + number;
          });
          if (Number(this.taskForm.condition2) < number) {
            return this.$message.warning(
              `任务次数不可低于任务条件可得${this.mainText}${
                this.isShowUnit ? "机会" : ""
              }`
            );
          }
        }

        this.$emit("update:copySteList", this.taskLevelList);
      }

      if (this.taskForm.type == 20) {
        if (!this.taskForm.orderStartTime || !this.taskForm.orderEndTime) {
          return this.$message.warning("请填写下单时间");
        }
        if (this.taskForm.orderStartTime && this.taskForm.orderEndTime) {
          const startTime = new Date(this.taskForm.orderStartTime).getTime();
          const endTime = new Date(this.taskForm.orderEndTime).getTime();
          const activityEndTime = new Date(this.activityEndTime).getTime();
          if (startTime > endTime) {
            return this.$message.warning("下单结束时间不能小于下单开始时间");
          }
          if (endTime > activityEndTime) {
            return this.$message.warning("下单结束时间不能晚于活动结束时间");
          }
        }
        // 指定商品-------------
        if (
          this.taskForm.skuType != 0 &&
          (!this.taskForm.skuIds.length || this.taskForm.skuIds.length < 1)
        ) {
          return this.$message.warning(
            `请选择${this.taskForm.skuType == 1 ? "指定" : "排除"}商品`
          );
        }
        let isLimit = false;
        let isLimitZero = false;
        this.taskOrderList.forEach((item) => {
          if (!item.limit || !item.giveNum) {
            isLimit = true;
          }
          if (item.limit == 0 && item.limit != "") {
            isLimitZero = true;
          }
        });
        if (isLimitZero) {
          return this.$message.warning("任务条件值需大于0");
        }
        if (isLimit) {
          return this.$message.warning("请填写任务条件");
        }
        if (!this.taskForm.condition2) {
          return this.$message.warning("请填写任务次数");
        }
        if (
          Number(this.taskOrderList[0].giveNum) >
          Number(this.taskForm.condition2)
        ) {
          return this.$message.warning(
            `任务次数不能小于任务条件的${this.mainText}次数`
          );
        }
        this.$emit("update:taskOrders", this.taskOrderList);
      }

      // 任务条件
      if (
        this.conditionValue.includes(this.taskForm.type) &&
        this.taskForm.type != 17 &&
        this.taskForm.type != 20
      ) {
        if (!this.taskForm.condition) {
          return this.$message.warning("请填写任务条件");
        }
      }
      // 商品
      if (this.goodsTypeList.includes(this.taskForm.type)) {
        if (this.taskForm.skuIds.length == 0) {
          const obj = this.taskTypeOptions.find(
            (item) => item.value == this.taskForm.type
          );
          return this.$message.warning(`请填写${obj.label}`);
        } else if (
          this.goodsLimitList.includes(this.taskForm.type) &&
          this.taskForm.condition > this.taskForm.skuIds.length
        ) {
          return this.$message.warning(
            `任务商品件数不得大于已选商品件数，请重新选择~`
          );
        }
      }
      // 任务次数
      if (
        this.taskForm.type == 18 ||
        this.taskForm.type == 12 ||
        this.taskForm.type == 16 ||
        (this.taskForm.type == 17 &&
          this.taskForm.orderCountType == 0 &&
          this.taskForm.giveType == 0)
      ) {
        if (!this.taskForm.condition2) {
          return this.$message.warning("请填写任务次数");
        }
      }
      // 抽奖次机会
      if (this.taskForm.type == 7) {
        if (!this.taskForm.giveLimit) {
          return this.$message.warning(`请填写${this.mainText}次数`);
        }
      }
      const obj = JSON.parse(JSON.stringify(this.taskForm));
      if (this.taskForm.type == 17) {
        obj.stepList = JSON.parse(JSON.stringify(this.taskLevelList));
      } else if (this.taskForm.type == 20) {
        obj.stepList = JSON.parse(JSON.stringify(this.taskOrderList));
      }
      const index = this.taskDataList.findIndex(
        (item) => item.type == this.taskForm.type
      );
      if (index != -1 && !this.isTaskEdit) {
        return this.$message.warning("列表已存在该类型任务，请勿重复添加~");
      } else {
        // 修改
        if (this.isTaskEdit) {
          const index = this.taskDataList.findIndex(
            (item) => item.type == this.taskRow.type
          );
          this.taskDataList.splice(index, 1, obj);
        } else {
          if (this.isTrueEdit) {
            this.taskDataList.push({ ...obj, isAdd: true });
          } else {
            this.taskDataList.push(obj);
          }
        }
      }
      this.$emit("update:taskList", this.taskDataList);
      this.taskDialog = false;
    },
    // 修改
    editTask(row, isLook) {
      const copyRow = JSON.parse(JSON.stringify(row));
      this.taskRow = row;
      this.isTaskEdit = true;
      this.taskForm = copyRow;
      // 指定商品规则兜底：老数据无该字段时默认整单计算
      this.taskForm.statsSkuType = copyRow.statsSkuType || 0;
      // 商品回显
      this.selectGoodsSkuList = copyRow.selectGoodsSkuList;
      this.taskDialog = true;
      this.taskIsLook = isLook;
      this.taskOrderList = JSON.parse(JSON.stringify(this.taskOrders));
      this.taskLevelList = JSON.parse(JSON.stringify(this.copySteList));
      // 购买商品新增下单店铺回显处理
      if (this.taskForm.type == 17) {
        this.goodsLimit = 500
        this.initData();
        if(this.taskForm.skuType ==1) {
          const isReq = this.taskForm.sellerSkuList.some((item) => {
            return item.itemList&&item.itemList.length>0;
          });
          if (!isReq) {
            const reqList = this.taskForm.sellerSkuList.map((item) => {
              return getTaobaoItemListSku({
                current: 1,
                size: item.skuIds.length,
                skuIds: item.skuIds,
                venderId: item.venderId,
              });
            });
            Promise.all(reqList).then((res) => {
              res.forEach((itemRes, index) => {
                this.taskForm.sellerSkuList[index].itemList = itemRes.data.records;
              });
            });
          }
        }
      } else {
        this.goodsLimit = 100
      }
    },
    // 删除
    deleteTask(row) {
      const index = this.taskDataList.findIndex(
        (item) => item.type == row.type
      );
      this.taskDataList.splice(index, 1);
    },
    // 上移
    upTask(index) {
      this.taskDataList[index] = this.taskDataList.splice(
        index - 1,
        1,
        this.taskDataList[index]
      )[0];
    },
    // 下移
    downTask(index) {
      this.taskDataList[index] = this.taskDataList.splice(
        index + 1,
        1,
        this.taskDataList[index]
      )[0];
    },
    NumChange(e, key, valueIndex) {
      let res = e;
      this.taskLevelList.forEach((item, index) => {
        if (valueIndex > index) {
          if (parseFloat(res) <= parseFloat(item[key])) {
            res = "";
          }
        }
      });
      return res;
    },
    NumChange2(e, key, valueIndex) {
      let res = e;
      this.taskOrderList.forEach((item, index) => {
        if (valueIndex > index) {
          if (parseFloat(res) <= parseFloat(item[key])) {
            res = "";
          }
        }
      });
      return res;
    },
    giveTypeChange(e) {
      if (e == 1) {
        this.taskLevelList = [
          {
            taskIndex: 1,
            limit: "",
            giveNum: "",
          },
        ];
      }
      if (e == 2) {
        this.taskLevelList = [
          {
            taskIndex: 1,
            limit: "",
            giveNum: "",
          },
          {
            taskIndex: 2,
            limit: "",
            giveNum: "",
          },
        ];
      }
    },
    addTaskLevel() {
      let postData = {
        taskIndex: 1,
        limit: "",
        giveNum: "",
      };
      postData.taskIndex = this.taskLevelList.length + 1;
      this.taskLevelList.push(postData);
    },
    delTaskLevel(index) {
      this.taskLevelList.splice(index, 1);
    },
    // 控制大于0 - 正数可包含小数点
    validateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ''); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf('.');
      if (decimalIndex !== -1) {
        newValue = newValue.slice(0, decimalIndex + 1) + newValue.slice(decimalIndex + 1).replace(/\./g, '');
      }
      if (parseFloat(newValue) > 999999.99) {
        newValue = '999999.99'; // 设置为最大值
      }
      this.taskForm.amtLimit = newValue.replace(/^0+(\d)/, '$1');
    },
    validateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ''); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ''); // 移除前导零
        if (newValue === '') {
          newValue = '0';
        }
      }
      if (parseInt(newValue) > 999) {
        newValue = '999'; // 设置为最大值
      }

      this.taskForm.itemTotalLimit = newValue;
    },
    // 控制大于0 - 正数可包含小数点
    inputValidateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ""); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf(".");
      if (decimalIndex !== -1) {
        newValue =
          newValue.slice(0, decimalIndex + 1) +
          newValue.slice(decimalIndex + 1).replace(/\./g, "");
      }
      if (parseFloat(newValue) > 999999.99) {
        newValue = "999999.99"; // 设置为最大值
      }
      return newValue.replace(/^0+(\d)/, "$1");
    },
    inputValidateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ""); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ""); // 移除前导零
        if (newValue === "") {
          newValue = "0";
        }
      }
      if (parseInt(newValue) > 999) {
        newValue = "999"; // 设置为最大值
      }

      return newValue;
    },
    // 商品组件回调
    selectGoodsChange(val) {
      if (val) {
        let isGoods = false;
        val.forEach((item) => {
          if (item.skuStatus != 1) {
            isGoods = true;
          }
        });
        //加权限判断
        if (this.isPremissionShow) {
          if (isGoods) {
            return this.$message.warning(
              "当前所选商品包含下架商品，请重新选择"
            );
          }
        }

        let valArr = [];
        this.selectGoodsSkuList = val;
        this.taskForm.selectGoodsSkuList = val;
        val.forEach((i) => {
          valArr.push(i.skuId);
        });
        this.taskForm.skuIds = valArr;
      }
      this.goodsState = false;
    },
    showGoods(limit = 100) {
      this.goodsLimit = limit;
      this.goodsState = true;
    },
    // 清空任务时间
    clearTaskTime() {
      this.taskForm.startTime = "";
      this.taskForm.endTime = "";
    },
    // 清空下单时间
    clearOrderTime() {
      this.taskForm.orderStartTime = "";
      this.taskForm.orderEndTime = "";
    },
    // 按商品/按订单切换
    handleCountTypeChange() {
      this.taskOrderList.forEach((item) => {
        item.limit = "";
      });
    },
    // 关闭
    taskClose() {
      this.taskIsLook = false;
      this.taskDialog = false;
    },
    // 新增任务
    addTask() {
      this.isTaskEdit = false;
      this.taskDialog = true;
      this.taskForm = {
        giveType: 0,
        countType: 1,
        taskDoType: 0,
        type: 1,
        taskTime: 1,
        condition: null,
        condition2: null,
        count: null,
        endTime: null,
        startTime: null,
        skuIds: [],
        selectGoodsSkuList: [],
        inviteLimit: null,
        jumpUrl: null,
        activityType: 2,
        skuType: 0,
        statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
        orderType: 0,
        orderCountType: 1,
        itemTotalLimit: null,
        amtLimit: null,
        orderEndTime: null,
        orderStartTime: null,
        orderPaymentType: 1,
        mergeOrder: false,
      };
      this.selectGoodsSkuList = [];
      this.taskTypeChange(1);
    },
    // 任务类型change
    taskTypeChange(e) {
      const obj = this.taskTypeOptions.find((item) => item.value == e);
      if (!this.conditionValue.includes(e)) {
        this.taskForm.condition = obj.taskCondition;
      } else {
        this.taskForm.condition = null;
        this.taskForm.condition2 = null;
        this.taskForm.activityType = 2;
      }
      // 任务次数
      if (e == 12) {
        this.taskForm.count = null;
      } else {
        this.taskForm.count = obj.taskCount;
      }
      // 购买商品 - tip：不能加入goodsTypeList 因为保存时不做限制
      if (this.taskForm.type == 17) {
        this.goodsLimit = 500
        this.initData();
        this.taskForm.skuIds = [];
        this.selectGoodsSkuList = [];
        this.taskForm.selectGoodsSkuList = [];
        this.taskForm.giveType = 0;
      }
      // 商品
      if (this.goodsTypeList.includes(e)) {
        this.taskForm.skuIds = [];
        this.selectGoodsSkuList = [];
        this.taskForm.selectGoodsSkuList = [];
      }
      if (e == 20) {
        this.taskForm.countType = 2;
        this.taskOrderList = [
          {
            taskIndex: 1,
            limit: "",
            giveNum: "",
          },
        ];
      }
      this.taskForm.taskTime = 1;
    },
  },
  mounted() {
    this.taskDataList = this.taskList;
  },
};
</script>
<style lang="scss" scoped>
.task-tip-wrap {
  padding-right: 10%;
}

.task-tip {
  margin-bottom: 16px;
}

.task-wrap {
  display: flex;
  align-items: center;
  &-radio {
    margin-right: 10px;
  }
}

.tip-red {
  color: red;
}

.skuType-label {
  /deep/ .el-form-item__label {
    padding-right: 3px;
  }
}

.book-good-wrap {
  display: flex;
  align-items: center;
}

.rule_box {
  background: #fafafa;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 0 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.input-w {
  width: 90px;
}

.extra-text {
  color: #ff8e0c;
}
.pdtb8 {
  padding: 8px 0;
}
</style>
